import { useEffect } from 'react'
import Router from 'next/router'
import { trackPage } from 'lib/tracking/segment'
import { getUrlPathname } from 'lib/helpers/getUrlPathname/getUrlPathname'

/**
 * Tracks a generic page view on mount and whenever the URL path changes. Query-only changes (sorting,
 * filters, tabs, opening a drawer) keep the user on the same page, so they don't count, whether or not
 * the navigation is shallow.
 */
export const useTrackPageViews = () => {
  useEffect(() => {
    let lastPathname = window.location.pathname

    trackPage()

    const handleRouteChangeComplete = (url: string) => {
      const pathname = getUrlPathname(url)

      if (pathname === lastPathname) {
        return
      }

      lastPathname = pathname
      trackPage()
    }

    Router.events.on('routeChangeComplete', handleRouteChangeComplete)
    return () => {
      Router.events.off('routeChangeComplete', handleRouteChangeComplete)
    }
  }, [])
}
